/* We can disable import/no-cycle here because we know that
  api only depends on the User module. */
// eslint-disable-next-line import/no-cycle
import api from '@/api';

const optionModule = (url, idKey) => ({
  namespaced: true,
  state() {
    return {
      options: [],
      loading: false,
      serverError: '',
    };
  },
  actions: {
    async fetchOptions({ commit, state }) {
      // only fetch if not already loaded
      if (state.options.length === 0 && !state.loading) {
        commit('SET_LOADING', true);
        await api.get(url)
          .then((response) => {
            commit('SET_OPTIONS', response.data);
            commit('SET_LOADING', false);
          })
          .catch(() => {
            commit('SET_LOADING', false);
          });
      }
    },
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_OPTIONS(state, options) {
      state.options = options;
    },
  },
  getters: {
    getProperty: state => (id, propertyName) => {
      if (state.options && state.options.some(p => p[idKey] === id)) {
        return state.options.filter(p => p[idKey] === id)[0][propertyName];
      }
      return '';
    },
    getName: (state, getters) => id => getters.getProperty(id, 'name'),
  },
});

export default optionModule;
